import React from "react";
import { useTranslation } from "react-i18next";

// Placeholder shown while a report's full data is still loading. Communicates
// "wait — these are placeholders" via a spinner + shimmering rows, and renders
// no action buttons (which would otherwise key off not-yet-known fields).
const SKELETON_ROW_WIDTHS = [62, 84, 48, 72, 56];

const ReportDetailsSkeleton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="details-section report-details-skeleton" aria-busy="true">
      <div className="report-loading-status" role="status">
        <span className="report-loading-spinner" aria-hidden="true" />
        <span className="report-loading-text">
          {t("report.loadingDetails")}
        </span>
      </div>

      <div className="report-skeleton-rows" aria-hidden="true">
        {SKELETON_ROW_WIDTHS.map((width, index) => (
          <div className="report-skeleton-row" key={index}>
            <span className="skeleton-bar report-skeleton-label" />
            <span
              className="skeleton-bar report-skeleton-value"
              style={{ width: `${width}%` }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportDetailsSkeleton;
